/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Button from 'components/common/Button';

export default function GenericConfirmationDialog({
  dialog,
  toggleDialog,
  dialogVariant,
  title,
  dialogMessage,
  buttonLabel,
}) {
  return (
    <Dialog data-testid="generic-confirmation-dialog" open={dialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <DialogStatus variant={dialogVariant} />
        <Typography component="h3" variant="h3">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>{dialogMessage}</DialogContent>
      <DialogActions>
        <Button data-testid="close-btn" color="default" onClick={() => toggleDialog(false)}>
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
